// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import global from './store/global.js'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import './utils/dialogDrag.js'
import './assets/css/vpage.css'

// 路由采集插件
import tracing from 'web-tracing'

//
import vkbeautify from 'vkbeautify'

const axiosInstance = axios.create({ timeout: 15000 })

Vue.prototype.vkbeautify = vkbeautify
Vue.prototype.$ = $
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.$http = axiosInstance
Vue.prototype.$global = global
Vue.use(Viewer)
Viewer.setDefaults({
  title: false,
  inline: true,
  navbar: false,
  toolbar: false,
  button: false,
  transition: false // 使用 CSS3 过度
})

Vue.use(tracing, {
  requestUrl: 'manage/operatingLog/importOperatingLog',
  appName: '检索系统',
  event: {
    core: true,
    unload: false
  }
  //   pv: true
  // eslint-disable-next-line no-undef
  //   ext: { ip: localStorage.getItem('ip') }
})
// tracing.setUserUuid(localStorage.getItem('userId'))
tracing.setUserUuid(localStorage.getItem('userId'))

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
router.beforeEach((to, from, next) => {
//   let newTo = Object.assign({}, to) // 创建一个新的to对象，而不是直接修改原来的to对象
  if (from.params.url != undefined && to.params.url == undefined) {
    let newTo = Object.assign({}, to)
    newTo.params.url = from.params.url
    newTo.fullPath = '/' + from.params.url + to.fullPath
    newTo.path = '/' + from.params.url + to.path
    next(newTo) // 传递新的to对象来替换原来的to对象
  } else {
    next()
  }
})
axiosInstance.interceptors.request.use(
  config => {
    if (localStorage.getItem('token')) {
      config.headers.Authorization = localStorage.getItem('token')
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

// 判断是否需要退出登录
function checkLogout (res) {
  const status = res.headers.status // status表示用户是否被禁用
  const system = res.headers.system // system表示用户可访问的系统, 第三位为当前系统
  if (status === '0') {
    ElementUI.Message.error('用户已被禁用')
  } else if (system && system[2] === '0') {
    ElementUI.Message.error('用户无权限访问当前系统')
  } else {
    return false
  }
  axiosInstance.post('retrieve/user/logout')
  localStorage.clear()
  setTimeout(() => {
    router.push('/')
    location.reload()
  }, 300)
  return true
}

const oldTokenSet = new Set()
// 判断是否需要更新权限
function updatePermission (res) {
  if (checkLogout(res)) {
    return true
  }
  const newToken = res.headers.authorization
  const oldToken = localStorage.getItem('token')
  if (!oldTokenSet.has(oldToken)) {
    oldTokenSet.add(oldToken)
  }
  if (oldTokenSet.size > 5) {
    oldTokenSet.delete(oldTokenSet.values().next().value)
  }
  if (
    oldToken &&
    newToken &&
    oldToken !== newToken &&
    !oldTokenSet.has(newToken)
  ) {
    localStorage.setItem('token', newToken)
    ElementUI.Message({
      message: '用户角色或权限已更新',
      type: 'warning'
    })
    setTimeout(() => {
      location.reload()
    }, 300)
    return true
  }
  return false
}

// axios 接口错误拦截
axiosInstance.interceptors.response.use(
  function (res) {
    if (updatePermission(res)) {
      return
    }
    if (res.data.status === 27) {
      ElementUI.Message.error('密码有效期已过，请修改密码后登录')
      return Promise.reject(res)
    }
    if (res.data.status && res.data.status !== 200) {
      // if (localStorage.getItem('token')) {
      //   ElementUI.Message.error(res.data.message)
      // }
      if (res.data.message) {
        ElementUI.Message.error(res.data.message)
      }
      return Promise.reject(res)
    } else {
      return res
    }
  },
  function (error) {
    if (updatePermission(error.response)) {
      return
    }
    if (error.response.status === 403) {
      // if (localStorage.getItem('token')) {
      //   ElementUI.Message.error(error.response.data)
      // }
      if (error.response.message) {
        ElementUI.Message.error(error.response.data)
      }
    }
    return Promise.reject(error)
  }
)

let blackList = ['/user/userInfo', '/user/myNote', '/user/viewHistory']

// 路由拦截
router.beforeEach((to, from, next) => {
  let temp = to.path
  if (to.params.url) {
    console.log('temp', temp)
    if (temp.indexOf('/user') !== -1) {
      temp = temp.substring(temp.indexOf('/user'))
      console.log('temp', temp)
    }
  }
  console.log(' to.path.indexOf(blackList)', blackList.indexOf(to.path))
  if (blackList.indexOf(temp) !== -1) {
    if (localStorage.getItem('isLogined') === 'true' && localStorage.getItem('userName') !== 'anonymity') {
      next()
    } else if (localStorage.getItem('userName') === 'anonymity') {
      ElementUI.Message.error('游客无法进行此操作')
      next()
      next('/home')
    } else {
      ElementUI.Message.error('用户需要登录才能进行操作')
      //   next()
      next(from.path)
    }
  } else {
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  beforeCreate () {
    Vue.prototype.$bus = this // 全局事件总线
  }
})



// WEBPACK FOOTER //
// ./src/main.js